import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div`
  svg {
    transition: transform 0.2s;
  }
  display: flex;
`;

export const UpIcon: React.FC<{
  className?: string;
  onClick?: () => void;
  fill?: string;
  title?: string;
}> = ({ className, onClick, fill, title }) => {
  return (
    <StyledRoot className={className} onClick={onClick} title={title}>
      <svg viewBox="0 0 24 24" width="16" height="16">
        <path fill="none" d="M0 0h24v24H0z" />
        <path
          fill={fill}
          d="M12 10.828l-4.95 4.95-1.414-1.414L12 8l6.364 6.364-1.414 1.414z"
        />
      </svg>
    </StyledRoot>
  );
};
